import IPaytableMapItem from "../../../../vendor_core/core/src/managers/contracts/configurations/IPaytableMapItem";
import BetModel from "../../../../vendor_core/core/src/model/BetModel";
import { IBetData } from "../../../../vendor_core/core/src/server/data/IBetData";
import CurrencyUtils from "../../../../vendor_core/core/src/utils/CurrencyUtils";
import BetDataParser from "../../../../vendor_core/src/server/parsers/BetDataParser";
import Configs from "../../../../vendor_core/src/vendorConfigs/Configs";
import BURPaytableModel from "../../models/BURPaytableModel";

export default class BURBetDataParser extends BetDataParser {
    public check(data: any) {
        return data?.data?.gameData?.betPerLine;
    }

    parse(data): IBetData[] {
        // Parsing the paytable map
        BURPaytableModel.setSizeBuckets(
            data.data.gameData.sizeBuckets.map((sb) => sb.join("-"))
        );
        const payouts = data.data.gameData.payTable;
        BURPaytableModel.symbols.forEach((_, id) => {
            if (payouts[id]) {
                BURPaytableModel.setSymbolPayouts(id, payouts[id]);
            }
        });

        if (Configs.settings) {
            let paytableMap: IPaytableMapItem[] = [];

            BURPaytableModel.symbol_payouts.forEach((payouts, symbolId) => {
                const symbol = BURPaytableModel.symbols.get(symbolId);
                payouts.forEach((multiplier, payoutIndex) => {
                    const key = `pt_sym_${symbol}_${payoutIndex + 1}`;
                    const paytableMapItem: IPaytableMapItem = {
                        key,
                        multiplier
                    };
                    paytableMap.push(paytableMapItem);
                });
            });

            Configs.settings.ptMap = paytableMap;
        }

        // let bets = this.calculateMultipliers(data.Response.Bet.attributes);
        // TODO
        // let minChips = parseInt(data.Response.Bet.attributes.minChips);
        // let maxChips = parseInt(data.Response.Bet.attributes.maxChips);
        BetModel.betDivisor = data.data.gameData.betDivisor;
        BetModel.currencyRate = data.data.gameData.currencyRate || 1;
        BetModel.currencyMultiplier = data.data.gameData.currencyMultiplier = 1;

        const currencyISO = data.data.gameData.currency || "EUR";
        const decimals = data.data.gameData.currencyDecimalPlaces || 2;
        const symbol = data.data.gameData.currencySymbol || "€";
        const multi = BetModel.currencyRate;
        const locale = data.locale || data.country; // TODO: backend does not send such property yet.

        const currencyLocalization = CurrencyUtils.createCurrencyLocalization(
            currencyISO,
            symbol,
            decimals,
            multi,
            locale
        );

        BetModel.setCurrency(currencyLocalization);

        let bets: number[] = data.data.gameData.betPerLine;
        bets = bets.map((bet) => bet * data.data.gameData.betDivisor);
        let coinSize =
            data.data.gameData.betPerLineDefault *
            data.data.gameData.betDivisor;
        let result: IBetData = {
            betMultipliers: [1],
            // creditValues:  Utils.parseStringifiedListOfNumbers(data.Response.Bet.attributes.validChips),
            // betMultipliers: Utils.parseStringifiedListOfNumbers(
            //     data.Response.Bet.attributes.validChips
            // ),
            currentBetMultiplier: 1,
            creditValues: bets,
            coinSize,
            coinSizeIndex: bets.indexOf(coinSize),
            minLinesAllowed: 1,
            maxLinesAllowed: 1,
            currency: {
                decimals: currencyLocalization.currency.decimals,
                symbol: currencyLocalization.currency.symbol,
                ISO: currencyLocalization.currency.ISO
            },
            allPossibleBets: this.parsePossibleBets(bets, 1),
            numLines: 1
        };

        return [result];
    }
}
